<div id="RevolutionUserPersonalisationComponent" class="min-h-[600px]">
  <div class="mx-auto py-0 md:px-6" id="general">
    @if (error && error.status !== 404) {
      <div
        class="mt-5 font-efSans text-sm text-mat-ef-red-secondary-500"
      >
        {{ 'general-error-message' | sharedTranslate }}
      </div>
    }
    
    @if (getError && getError.status !== 404) {
      <div
        class="mt-5 font-efSans text-sm text-mat-ef-red-secondary-500"
      >
        {{ 'general-error-message' | sharedTranslate }}
      </div>
    }
    
    @if (!getError) {
      <h6 class="font-efSans text-base text-mat-ef-revolution-primary-500">
        <T
          str="If you have any preference or specific search criteria for vehicle you can specify them here:"
          key="customerPortal.customer-portal.personalization.brands.notice"
          tags="customer-portal, 3.1"
        ></T>
      </h6>

      <div
        class="uppercase text-mat-ef-revolution-primary-500 mt-5 text-base font-bold"
      >
        <T
          str="Brands"
          key="customerPortal.customer-portal.personalization.brands"
          tags="customer-portal, 3.1"
        ></T>
      </div>
      <mat-divider class="relative w-full mb-5"></mat-divider>

      @if (error) {
        <div>
          {{ 'general-error-message' | sharedTranslate }}
        </div>
      }

      <div class="flexboxContainer flex flex-wrap gap-3.5">
        @for (brand of brands; track brand.name) {
          <button
            data-cy="personalization-brand"
            mat-button
            mat-raised-button
            (click)="selectBrand(brand)"
            class="revolution shadow-none flex-grow h-9"
            [color]="checkBrand(brand) ? 'secondary' : 'basic'"
          >
            {{ brand.name }}
          </button>
        }
      </div>
      <div
        class="uppercase text-mat-ef-revolution-primary-500 mt-5 text-base font-bold"
      >
        <T
          str="Body Type"
          key="customerPortal.customer-portal.personalization.bodyType"
          tags="customer-portal, 3.1"
        ></T>
      </div>
      <mat-divider class="relative w-full mb-5"></mat-divider>

      <div class="grid grid-cols-2 md:grid-cols-5 pb-6">
        @for (bodyType of bodyTypes; track bodyType) {
          <span class="py-5 px-1 m-auto">
            <button
              data-cy="personalization-body-type"
              mat-button
              mat-raised-button
              class="revolution vehicle-btn"
              (click)="selectBodyType(bodyType)"
              [color]="checkBodyType(bodyType) ? 'secondary' : 'basic'"
            >
              <div class="flex flex-col items-center">
                <mat-icon [svgIcon]="bodyTypeIcons[bodyType]"></mat-icon>
                <span>
                  <ng-container
                    *ngTemplateOutlet="
                      sharedService.template('transifexTranslation');
                      context: {
                        str: bodyType,
                        prefix:
                          'customerPortal.customer-portal.personalization.bodyType.'
                      }
                    "
                  ></ng-container>
                </span>
              </div>
            </button>
          </span>
        }
      </div>
      <div
        class="uppercase text-mat-ef-revolution-primary-500 mt-5 text-base font-bold"
      >
        <T
          str="Transmission"
          key="customerPortal.customer-portal.personalization.transmission"
          tags="customer-portal, 3.1"
        ></T>
      </div>
      <mat-divider class="relative w-full mb-5"></mat-divider>

      <div class="grid">
        <span class="py-5 px-1">
          @for (transmission of transmissions; track transmission) {
            <mat-checkbox
              data-cy="personalization-transmition"
              class="py-2 px-1 mr-4"
              (change)="selectTransmission(transmission)"
              color="primary"
              [checked]="checkTransmission(transmission)"
            >
              <ng-container
                *ngTemplateOutlet="
                  sharedService.template('transifexTranslation');
                  context: {
                    str: transmission,
                    prefix: 'customerPortal.customer-portal.vehicle.equipment.',
                    noLowerCase: true
                  }
                "
              ></ng-container>
            </mat-checkbox>
          }
        </span>
      </div>
      <div
        class="uppercase text-mat-ef-revolution-primary-500 mt-5 text-base font-bold"
      >
        <T
          str="Vehicle use"
          key="customerPortal.customer-portal.personalization.vehicle-use"
          tags="customer-portal, 3.1"
        ></T>
      </div>
      <mat-divider class="relative w-full mb-5"></mat-divider>

      <div class="grid">
        <span class="py-5 px-1">
          @for (vehicleUsage of vehicleUsages; track vehicleUsage) {
            <mat-checkbox
              data-cy="personalization-usage"
              class="py-2 px-1 mr-4"
              (change)="selectVehicleUsage(vehicleUsage)"
              color="primary"
              [checked]="checkVehicleUsage(vehicleUsage)"
            >
              <ng-container
                *ngTemplateOutlet="
                  sharedService.template('transifexTranslation');
                  context: {
                    str: vehicleUsage,
                    prefix: 'customerPortal.customer-portal.vehicle.equipment.',
                    noLowerCase: true
                  }
                "
              ></ng-container>
            </mat-checkbox>
          }
        </span>
      </div>
      <div
        class="uppercase text-mat-ef-revolution-primary-500 mt-5 text-base font-bold"
      >
        <T
          str="Fuel type"
          key="customerPortal.customer-portal.personalization.fuel-type"
          tags="customer-portal, 3.1"
        ></T>
      </div>
      <mat-divider class="relative w-full mb-5"></mat-divider>

      <div class="grid">
        <span class="py-5 px-1">
          @for (fuelType of fuelTypes; track fuelType) {
            <mat-checkbox
              data-cy="personalization-fuel-type"
              class="py-2 px-1 mr-4"
              (change)="selectFuelType(fuelType)"
              color="primary"
              [checked]="checkFuelType(fuelType)"
            >
              <ng-container
                *ngTemplateOutlet="
                  sharedService.template('transifexTranslation');
                  context: {
                    str: fuelType,
                    prefix: 'customerPortal.customer-portal.vehicle.equipment.',
                    noLowerCase: true
                  }
                "
              ></ng-container>
            </mat-checkbox>
          }
        </span>
      </div>
      <div
        class="uppercase text-mat-ef-revolution-primary-500 mt-5 text-base font-bold"
      >
        <T
          str="Powertrain"
          key="customerPortal.customer-portal.personalization.powertrain"
          tags="customer-portal, 3.1"
        ></T>
      </div>
      <mat-divider class="relative w-full mb-5"></mat-divider>
      <div class="grid gap-14">
        <div class="col-span-1">
          <div class="grid">
            @for (powertrain of powertrains; track powertrain) {
              <mat-checkbox
                data-cy="personalization-powertrain"
                class="py-2 px-1 mr-4"
                (change)="selectPowertrains(powertrain)"
                color="primary"
                [checked]="checkPowertrains(powertrain)"
              >
                <ng-container
                  *ngTemplateOutlet="
                    sharedService.template('transifexTranslation');
                    context: {
                      str: powertrain,
                      prefix: 'customerPortal.customer-portal.vehicle.equipment.',
                      noLowerCase: true
                    }
                  "
                ></ng-container>
              </mat-checkbox>
            }
          </div>
          <div
            class="uppercase text-mat-ef-revolution-primary-500 mt-5 text-base font-bold"
          >
            <T
              str="Equipment level"
              key="customerPortal.customer-portal.personalization.equipment-level"
              tags="customer-portal, 3.1"
            ></T>
          </div>
          <mat-divider class="relative w-full mb-5"></mat-divider>

          <mat-radio-group class="grid">
            @for (equipmentLevel of equipmentLevels; track equipmentLevel) {
              <mat-radio-button
                data-cy="personalization-equipment-level"
                class="py-2 px-1"
                [checked]="checkEquipmentLevels(equipmentLevel)"
                (change)="selectEquipmentLevels(equipmentLevel)"
                color="primary"
                value="{{ equipmentLevel }}"
              >
                <ng-container
                  *ngTemplateOutlet="
                    sharedService.template('transifexTranslation');
                    context: {
                      str: equipmentLevel,
                      prefix: 'customerPortal.customer-portal.vehicle.equipment.',
                      noLowerCase: true
                    }
                  "
                ></ng-container>
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </div>

      <div
        class="uppercase text-mat-ef-revolution-primary-500 mt-5 text-base font-bold"
      >
        <T
          str="Energy efficiency"
          key="customerPortal.customer-portal.personalization.energy-efficiency"
          tags="customer-portal, 3.1"
        ></T>
      </div>
      <mat-divider class="relative w-full mb-5"></mat-divider>

      <div class="grid">
        @for (energyEfficiency of energyEfficiencies; track energyEfficiency) {
          <mat-checkbox
            data-cy="personalization-energy-efficiency"
            class="py-2 px-1"
            (change)="selectEnergyEfficiency(energyEfficiency)"
            color="primary"
            [checked]="checkEnergyEfficiency(energyEfficiency)"
          >
            <div
              class="energy-efficiency-class h-6 leading-6 pl-2.5 uppercase text-xl text-white font-bold"
              [ngClass]="efficiencyClassArrowColor(energyEfficiency)"
            >
              {{ energyEfficiency }}
            </div>
          </mat-checkbox>
        }
      </div>

      <div
        class="uppercase text-mat-ef-revolution-primary-500 mt-5 text-base font-bold"
      >
        <T
          str="Vehicle color"
          key="customerPortal.customer-portal.personalization.vehicle-color"
          tags="customer-portal, 3.34"
        ></T>
      </div>
      <mat-divider class="relative w-full mb-5"></mat-divider>

      <div class="grid grid-cols-2 pb-6 md:grid-cols-4">
        @for (color of vehicleColor; track color) {
          <mat-checkbox
            data-cy="personalization-vehicle-color"
            class="py-2 px-1"
            color="primary"
            (change)="selectVehicleColor(color)"
            [checked]="checkVehicleColor(color)"
          >
            <div class="vehicle-color-checkbox-label">
              <div
                class="vehicle-color-preview"
                [ngClass]="'vehicle-color-' + color.toLowerCase()"
              >
              </div>
              <ng-container
                *ngTemplateOutlet="
                  sharedService.template('transifexTranslation');
                  context: {
                    str: color,
                    prefix: 'customerPortal.customer-portal.personalization.vehicle-color.',
                    noLowerCase: true
                  }
                "
              ></ng-container>
            </div>
          </mat-checkbox>
        }
      </div>

      <div class="flex flex-row-reverse max-w-[1000px]">
        <button
          data-cy="personalization-submit"
          mat-button
          mat-flat-button
          color="secondary"
          id="saveButton"
          class="revolution my-5 mx-0 px-7"
          (click)="savePersonalization()"
          [disabled]="loading || saveIsDisabled"
        >
          @if (loading) {
            <mat-spinner [diameter]="16" class="m-2"></mat-spinner>
          }
          <span>{{ 'save' | sharedTranslate }}</span>
        </button>
      </div>
    }
  </div>
</div>
